/**
 * Meta AddToCart bridge for PageFly product pages.
 * Fires fbq('track', 'AddToCart') once after a successful /cart/add.js response.
 * Tracking only — does not modify cart, layout, or product behavior.
 */
(function () {
  if (window.__bbMetaAtcBridgeInit) return;
  window.__bbMetaAtcBridgeInit = true;

  var DEDUP_MS = 3000;
  var recent = {};

  function currencyCode() {
    return (
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD'
    );
  }

  function once(key, fn) {
    var now = Date.now();
    if (recent[key] && now - recent[key] < DEDUP_MS) return;
    recent[key] = now;
    fn();
  }

  function isCartAddUrl(url) {
    return url && String(url).indexOf('/cart/add') !== -1;
  }

  function trackFromLineItem(item) {
    if (!item || item.status === 'error' || item.message || !item.variant_id) return;
    if (typeof window.fbq !== 'function') return;

    var variantId = String(item.variant_id);
    var qty = item.quantity || 1;
    var value =
      (item.final_line_price || item.line_price || item.price || 0) / 100;
    if (!value && item.final_price) {
      value = (item.final_price * qty) / 100;
    }

    once(['meta-atc', variantId, qty].join(':'), function () {
      try {
        window.fbq('track', 'AddToCart', {
          content_ids: [variantId],
          content_type: 'product',
          content_name: item.product_title || item.title || '',
          contents: [
            {
              id: variantId,
              quantity: qty,
              item_price: value / qty || value
            }
          ],
          value: value,
          currency: currencyCode()
        });
      } catch (e) {}
    });
  }

  function handleResponse(response) {
    if (!response || !response.ok) return;
    response
      .clone()
      .json()
      .then(trackFromLineItem)
      .catch(function () {});
  }

  if (!window.__bbMetaFetchPatched) {
    window.__bbMetaFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var req = args[0];
      var url = req && req.url ? req.url : req;
      return origFetch.apply(this, args).then(function (res) {
        if (isCartAddUrl(url)) handleResponse(res);
        return res;
      });
    };
  }

  if (!window.__bbMetaXhrPatched) {
    window.__bbMetaXhrPatched = true;
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__bbMetaUrl = url;
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (isCartAddUrl(xhr.__bbMetaUrl)) {
        xhr.addEventListener('load', function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          try {
            trackFromLineItem(JSON.parse(xhr.responseText));
          } catch (e) {}
        });
      }
      return origSend.apply(this, arguments);
    };
  }
})();
